module.exports = __webpack_public_path__ + "static/media/add-flat-icon.354ee6c4.svg";